import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import moment from 'moment';
import { useTranslations } from 'next-intl';
import React from 'react';
import { useLocalization } from '@/hooks/useLocalization';

export interface IProps {
  product: SearchProduct;
}

const OverlayBanner: React.FC<IProps> = ({ product }) => {
  const t = useTranslations('common');
  const { azs, location } = useLocalization();

  const { isOpen, nextOpening } = useLocalization();

  let deliveryType = 'express';
  if (azs.length > 0) {
    deliveryType = azs[0].deliveryType;
  }

  if (product.deliveryType !== deliveryType) {
    return (
      <div
        style={{
          backgroundColor: '#43d9a399',
          fontWeight: 'bold',
          textShadow: '1px 1px #00000040',
        }}
        className="absolute bottom-0 rounded-xs bg-black/70 w-full text-white p-1 max-h-[100px] min-h-[60px] h-auto leading-tight text-center flex flex-col justify-center"
      >
        <div>{t('OverlayBanner.Available for Shipping')}</div>
      </div>
    );
  }

  if (!location?.coordinates.lat || !location?.coordinates.lng) {
    return null;
  }

  if (azs.length === 0) {
    return null;
  }

  if (!nextOpening) {
    return null;
  }

  /**
   * Se è disponibile o si è in modalità ecommerce non renderizzare
   */
  if (isOpen || deliveryType === 'ecommerce') {
    return null;
  }

  if (!product.inStock) {
    return (
      <div className="absolute bottom-0 rounded-xs bg-black/70 w-full text-white p-1 max-h-[100px] min-h-[60px] h-auto leading-tight text-center flex flex-col justify-center">
        <div>{t('OverlayBanner.product-not-available')}</div>
      </div>
    );
  }

  const now = moment();
  let message = '';

  if (nextOpening.dayOfYear() === now.dayOfYear()) {
    // oggi
    message = nextOpening.format(
      `[${t('OverlayBanner.available')}] [${t('OverlayBanner.from')}] HH:mm`,
    ); // prossima ora
  } else if (nextOpening.day() === now.day() + 1) {
    // domani
    message = nextOpening.format(
      `[${t('OverlayBanner.available')}] [${t('OverlayBanner.tomorrow')}] [${t(
        'OverlayBanner.from',
      )}] HH:mm`,
    ); // domani dalle ora
  } else {
    message = nextOpening.format(
      `[${t('OverlayBanner.available')}] dddd [${t(
        'OverlayBanner.from',
      )}] HH:mm`,
    );
  }

  return (
    <div className="absolute bottom-0 rounded-xs bg-black/70 w-full text-white p-1 max-h-[100px] min-h-[60px] h-auto leading-tight  text-center flex flex-col justify-center">
      <div>{message.charAt(0).toUpperCase() + message.slice(1)}</div>
    </div>
  );
};

export default OverlayBanner;
